/**
 * The definition editor's pickers. Read once per editor open and kept for
 * five minutes: the CI jobs come from GitLab's lint API under the viewer's
 * credential, and they change only when the CI configuration does.
 */

import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { api } from '@services/api';
import { API_PATHS } from '@utils/constants';
import { EditorOptionsSchema, type EditorOptions } from '../schemas/editorOptions.schemas';

const STALE_MS = 5 * 60_000;

export async function getEditorOptions(projectId: string): Promise<EditorOptions> {
  const response = await api.get(`${API_PATHS.projectAgentRuns(projectId)}/editor-options`);
  return EditorOptionsSchema.parse(response.data);
}

export function useEditorOptions(projectId: string): UseQueryResult<EditorOptions> {
  return useQuery({
    queryKey: ['projectPanel', projectId, 'editorOptions'],
    queryFn: () => getEditorOptions(projectId),
    staleTime: STALE_MS,
    retry: 1,
  });
}
